import { render, staticRenderFns } from "./ExpressLabelsTableUser.vue?vue&type=template&id=3c9c99b8&scoped=true"
import script from "./ExpressLabelsTableUser.vue?vue&type=script&lang=js"
export * from "./ExpressLabelsTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9c99b8",
  null
  
)

export default component.exports